import React from 'react'

import { colors, Stack } from '@zet/design-system'

const MarkAsSelected = () => {
  return (
    <Stack
      className="absolute -right-[2] top-1 border-2"
      style={{
        borderRadius: 1000,
        height: 12,
        width: 12,
        borderColor: colors.neutral.white100,
        backgroundColor: colors.warning[150],
        overflow: 'visible',
      }}
    />
  )
}

export default MarkAsSelected
